<template>
    <div class="tips-box" v-if="showTips">
        <div class="mask"></div>
        <div class="content">
            <div class="info">
                <div class="top" />
                <div class="info-title">
                    {{title}}
                </div>
                <div class="info-content">
                    {{content}}
                </div>
            </div>
        </div>
        <div class="close" @click="closeTips" />
    </div>
</template>

<script>
export default {
    props:{
        showTips:{
            type:Boolean,
            default: false
        },
        title:{
            type:String,
            default: '提示'
        },
        content:{
            type:String,
            default:'内容'
        }
    },
    data(){
        return{

        }
    },
    methods:{
        closeTips(){
            this.$emit('closeTips')
        }
    }
}
</script>

<style lang="scss" scoped>
.tips-box {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
    z-index: 1001;
	.mask {
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		background: rgba(0, 0, 0, .3);
        opacity: 1;
	}
	.content {
		position: absolute;
		padding: 0.12rem;
		top: 39%;
		left: 50%;
		transform: translate(-50%, -50%);
		background: linear-gradient(0deg, #f3bc7d 0%, #fbecc1 100%);
		border-radius: 0.2rem;
		box-shadow: 0 0 0.2rem rgba(255, 255, 255, .5);
		&.border {
			&:before, &:after {
				position: absolute;
				content: '';
				display: block;
				top: -0.20rem;
				width: 0.22rem;
				height: 0.20rem;
				background: #DDA743;
				border-radius: 50% 50% 0 0;
			}
			&:before {
				left: 0.66rem;
			}
			&:after {
				right: 0.68rem;
			}
		}
	}
	.info {
		position: relative;
		z-index: 2;
		width: 5.40rem;
		background: #fff;
		box-shadow: 0px 0px 0.09rem 0px rgba(223, 202, 140, 0.5);
		border-radius: 0.2rem;
		padding: 1.10rem 0.23rem 0.4rem;
		box-sizing: border-box;

	}
	.top {
		position: absolute;
		left: 50%;
		transform: translateX(-50%);
		top: -0.24rem;
		width: 4.24rem;
		height: 1rem;
		background: url('./../../assets/prize-empty_tips.png');
		background-size: 100%;
	}
	.info-title {
		z-index: 2;
		position: absolute;
		top: 0;
		left: 50%;
		transform: translateX(-50%);
		font-size: 0.36rem;
		color: #D38B24;
	}
    .info-content{
        font-size: 0.28rem;
        font-weight: 500;
        color: #D38B24;
        line-height: 0.4rem;
        text-align: left;
        height: 4.27rem;
        overflow: auto;
    }
    .close{
        width: 0.6rem;
        height: 0.6rem;
        position: absolute;
        left: 50%;
        bottom: 2.64rem;
        transform: translateX(-50%);
		background: url('../../assets/prize-close.png');
		background-size: 100%;
    }
}
</style>